<div [ngClass]="{'active': active  }" [class]="extraClasses" class="flex flex-col items-stretch bg-white">
    <div zenButton (click)="clicked()">
        <ng-content select="[head]"></ng-content>
    </div>
    <div class="accordion-body">
        <div class="accordion-body-inner flex flex-col">
            <ng-content select="[body]"></ng-content>
        </div>
    </div>
</div>
